import { DeliveryOrder } from '../delivery-order';
import { DeliveryOrderLocation } from '../delivery-order-location';
import { DeliveryOrderDriver } from '../driver/delivery-order-driver';

export const DeliveryOrderGroupTrackingSchema = {
    drivers: [DeliveryOrderDriver],
    locations: [DeliveryOrderLocation],
    orders: [DeliveryOrder],
};
